/**
 * Thank You Page & Contact Form Submission Logic
 */

(function () {
  'use strict';

  function initThankYouView() {
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    var path = window.location.pathname || '';

    // 0. Do NOT show thank-you view or update URL while user is solving captcha challenge
    if (path.indexOf('/challenge') !== -1 || path.indexOf('/captcha') !== -1) {
      return;
    }

    var isPosted =
      search.indexOf('contact_posted=true') !== -1 ||
      hash.indexOf('contact_posted=true') !== -1 ||
      sessionStorage.getItem('contact_posted') === 'true';

    var formSource = sessionStorage.getItem('submitted_form_source') || '';

    var isThankYouUrl =
      search.indexOf('thank-you=') !== -1 ||
      path.indexOf('/pages/thank-you') !== -1;

    // 1. Update Browser URL address bar cleanly via query parameter to prevent 404s
    if (isPosted && !isThankYouUrl) {
      var thankYouParam = 'contact-us-thank-you';

      if (formSource === 'side-button' || hash.indexOf('ContactUsCard') !== -1 || search.indexOf('ContactUsCard') !== -1) {
        thankYouParam = 'contact-us-thank-you';
      } else if (formSource === 'blog-page' || path.indexOf('/blogs') !== -1 || hash.indexOf('ContactFormSidebar') !== -1) {
        thankYouParam = 'blog-thank-you';
      }

      var targetUrl = path + '?thank-you=' + thankYouParam;

      try {
        window.history.replaceState({ contactPosted: true }, '', targetUrl);
      } catch (e) {}
    }
    
    if (path.indexOf('/pages/thank-you') !== -1) {
      setTimeout(fireThankYouConfetti, 200);
      sessionStorage.removeItem('contact_posted');
      sessionStorage.removeItem('submitted_form_source');
      return;
    }

    var tyView = document.getElementById('contact-form-thank-you-view');
    var cfView = document.getElementById('contact-form-fields-view');

    if (isPosted || (tyView && tyView.getAttribute('data-show-thank-you') === 'true')) {
      if (tyView) tyView.style.display = 'block';
      if (cfView) cfView.style.display = 'none';

      var secInner = tyView ? tyView.closest('.section__inner') : null;
      if (secInner) {
        var headings = secInner.querySelectorAll('.title-wrapper, .banner__box');
        headings.forEach(function (el) {
          if (!tyView.contains(el)) el.style.display = 'none';
        });
      }

      setTimeout(fireThankYouConfetti, 200);
      sessionStorage.removeItem('contact_posted');
      sessionStorage.removeItem('submitted_form_source');
    }

    document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        sessionStorage.setItem('contact_posted', 'true');

        if (form.id === 'ContactUsCardContactForm' || form.classList.contains('contact-us-card-form')) {
          sessionStorage.setItem('submitted_form_source', 'side-button');
        } else if (form.id === 'ContactFormSidebar' || form.classList.contains('sidebar-contact-form')) {
          sessionStorage.setItem('submitted_form_source', 'blog-page');
        } else {
          sessionStorage.setItem('submitted_form_source', 'contact-us-page');
        }
      });
    });
  }

  // Celebration Confetti Crackers Canvas Animation
  function fireThankYouConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas =
      document.getElementById('contact-thank-you-confetti-canvas') ||
      document.querySelector('.thank-you-confetti-canvas');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var width = (canvas.width = canvas.offsetWidth || window.innerWidth);
    var height = (canvas.height = canvas.offsetHeight || 500);

    var colors = ['#e31c1c', '#ffab68', '#1c70be', '#21f996', '#ffffff', '#ffd700'];
    var particles = [];
    var particleCount = 55;

    for (var i = 0; i < particleCount; i++) {
      particles.push({
        x: width / 2,
        y: height / 3,
        vx: (Math.random() - 0.5) * 14,
        vy: (Math.random() - 0.7) * 14,
        size: Math.random() * 8 + 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        vRot: (Math.random() - 0.5) * 12,
        opacity: 1,
      });
    }

    var frameCount = 0;

    function render() {
      ctx.clearRect(0, 0, width, height);
      var activeParticles = 0;

      particles.forEach(function (p) {
        if (p.opacity <= 0) return;
        activeParticles++;
        p.x += p.vx;
        p.y += p.vy;
        p.vy += 0.25;
        p.rotation += p.vRot;
        p.opacity -= 0.01;

        ctx.save();
        ctx.globalAlpha = Math.max(p.opacity, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
        ctx.restore();
      });

      if (activeParticles > 0 && frameCount < 200) {
        frameCount++;
        requestAnimationFrame(render);
      } else {
        ctx.clearRect(0, 0, width, height);
      }
    }

    setTimeout(render, 100);
  }

  window.fireThankYouConfetti = fireThankYouConfetti;

  // Run initialization on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThankYouView);
  } else {
    initThankYouView();
  }
})();
